import React from "react";
import { Box, Text, Link as ChakraLink, Icon } from "@chakra-ui/react";

// Why Us Box Component with enhanced design
const WhyUsBox = ({ icon, title, description, linkText, linkUrl }) => {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="2xl"
      p={8}
      width={{ base: "100%", md: "350px" }}
      textAlign="center"
      boxShadow="md"
      _hover={{
        boxShadow: "2xl",
        transform: "translateY(-8px)",
        borderColor: "orange.400",
      }}
      transition="all 0.3s ease"
      position="relative"
      overflow="hidden"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "4px",
        bgGradient: "linear(to-r, orange.400, orange.600)",
        opacity: 0,
        transition: "opacity 0.3s ease",
      }}
      sx={{
        "&:hover::before": {
          opacity: 1,
        },
      }}
    >
      <Box
        bg="orange.50"
        borderRadius="full"
        w="80px"
        h="80px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mx="auto"
        mb={6}
      >
        <Icon as={icon} boxSize={10} color="orange.500" />
      </Box>
      <Text fontWeight="700" fontSize="2xl" mb={4} color="gray.900">
        {title}
      </Text>
      <Text fontSize="md" mb={6} color="gray.600" lineHeight="1.7">
        {description}
      </Text>
      <ChakraLink
        href={linkUrl}
        fontWeight="600"
        color="orange.500"
        fontSize="sm"
        _hover={{ color: "orange.600", textDecoration: "underline" }}
        transition="all 0.2s"
      >
        {linkText} →
      </ChakraLink>
    </Box>
  );
};

export default WhyUsBox;
